import { subWeeks } from 'date-fns'
import { EXPIRATION_TYPES } from './consts'
import type { EditVehicleServicePlanForm } from './types'
import type {
  VehicleExpirationNode,
  VehicleServicePlanMutationInput,
} from './types.graphql'

export const getVehicleExpirationTypeName = ({
  expiration,
  name,
  fallback = '-',
}: {
  expiration?: VehicleExpirationNode
  name?: string
  fallback?: string
}): string => {
  const resolvedName = name ?? expiration?.expirationType?.name
  if (!resolvedName) return fallback
  return EXPIRATION_TYPES[resolvedName] ?? resolvedName ?? fallback
}

/**
 * The service plan modal's form as mutation input. The notification time is
 * stored as an absolute datetime but entered as a number of weeks before the
 * visit, and both the responsible user and the time are dropped when the
 * notification checkbox is off.
 */
export function getVehicleServicePlanInput(
  form: EditVehicleServicePlanForm,
  hasNotification: boolean
): VehicleServicePlanMutationInput {
  return {
    name: form.name,
    description: form.description,
    scheduledStart: form.scheduledStart,
    scheduledEnd: form.scheduledEnd,
    status: form.status,
    workshopName: form.workshopName,
    serviceType: form.serviceType,
    responsibleUser: hasNotification ? form.responsibleUser : null,
    notificationTime: hasNotification
      ? subWeeks(form.scheduledStart, form.notificationTime)
      : null,
  }
}
